import { render, staticRenderFns } from "./ProductSalesPrintLayout.vue?vue&type=template&id=32ebb990"
import script from "./ProductSalesPrintLayout.vue?vue&type=script&lang=js"
export * from "./ProductSalesPrintLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports